export default "__VITE_ASSET__DsMFLRG$__"